import React from 'react'
import pt from 'prop-types'

import SearchTop from '../../icon/SearchTop'

const Search = ({ openMod, pathname }) => {
  const isActive = !!pathname.startsWith('/search')
  return (
    <div
      className={'main-menu-item ' + (isActive && 'main-menu-item--active')}
      onClick={e => {
        openMod({ type: 'search', success: true })
      }}
    >
      <SearchTop />
    </div>
  )
}

Search.propTypes = {
  openMod: pt.func,
  pathname: pt.string
}

export default Search
